import { ExtensionTypes } from './types'

interface ExtensionColorsObject {
  primary: string
  secondary: string
  tertiary: string
}

export const extensionColors: Record<ExtensionTypes, ExtensionColorsObject> = Object.freeze({
  luoxDirectMarketing: {
    primary: '#D7FD7E',
    secondary: '#014751',
    tertiary: '#014751',
  },
  luox: {
    primary: '#D7FD7E',
    secondary: '#014751',
    tertiary: '#014751',
  },
  ostrom: {
    primary: '#16295A',
    secondary: '#21C0B0',
    tertiary: '#fff',
  },
  inexogy: {
    primary: '#e6e6e6',
    secondary: '#5cc244',
    tertiary: '#4a4a4a',
  },
  tibber: {
    primary: '#25B8CC',
    secondary: '#003B4F',
    tertiary: '#FFFFFF',
  },
  eon: {
    primary: '#961482',
    secondary: '#EA1B0A',
    tertiary: '#fff',
  },
  ai360PowerShare: {
    primary: '#5CC244',
    secondary: '#5CC244',
    tertiary: '#fff',
  },
  ai360PowerFix: {
    primary: '#FCB225',
    secondary: '#FCB225',
    tertiary: '#fff',
  },
})
